import { createAction, createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import _ from "lodash";
import { apiCallBegan } from "./api";
import {
  arrayToObject,
  arrayToObjectForMyQuotes,
  convertArrayOfObjectsToId,
  PossibleClientDetailsStatus,
  coverTableToCoverTypeObject,
  coverTypeObjectToRows,
  PossibleCols,
} from "./helperfuncs";
const ordercoverTypeTableAsPerDefaultPolicie = ({
  covertypetable,
  covertypes,
}) => {
  let newcovertypetable = {};

  for (let code in covertypes) {
    if (code in covertypetable) {
      newcovertypetable[code] = covertypetable[code];
    }
  }

  return newcovertypetable;
};

const slice = createSlice({
  name: "mybinder",
  initialState: {
    gettingMyBinders: false,
    gettingMyBindersFailed: false,
    gettingMyBindersSuccess: false,
    covertypetable: null,
    rows: [],
    covers: null,
    covertypes: null,
    locationAddresses: {},
    isLoading: false,
    currentClientDetails: {},
    table: {},
  },
  reducers: {
    gettingBinderDetailsIsLoading: (mybinder, action) => {
      mybinder.isLoading = true;
    },
    gettingBinderDetailsSuccess: (mybinder, action) => {
      mybinder.isLoading = false;
      mybinder.selectedBinderDetails = action.payload;
      let covers = action?.payload?.binderdetails?.allcovers;

      if (action?.payload?.binderdetails?.covers) {
        for (let covid in action?.payload?.binderdetails?.covers) {
          for (let cov of covers) {
            if (cov.covertypecode == "LOCATION") {
              continue;
            } else if (cov?.id == covid && !cov?.covervalue) {
              cov.covervalue = action?.payload?.binderdetails?.covers[covid];
            }
          }
        }
      }

      let covertypetable = coverTableToCoverTypeObject({
        covers: covers,
      });
      //#endregion
      mybinder.covers = arrayToObject(
        action?.payload.binderdetails?.allcovers,
        "id"
      );
      mybinder.locationAddresses =
        action?.payload?.binderdetails?.locationAddresses;
      let covertypes_withoutLocations = arrayToObject(
        action?.payload?.binderdetails?.covertypes,
        "code"
      );

      mybinder.covertypes = { ...covertypes_withoutLocations };

      //order covertypes as per defaultorder
      mybinder.covertypetable = ordercoverTypeTableAsPerDefaultPolicie({
        covertypetable,
        covertypes: mybinder?.covertypes,
      });
      // convert covertype table to rows
      let { rows, covertypeexpandprop, locationExpandProp } =
        coverTypeObjectToRows({
          covertypeobject: mybinder?.covertypetable,
          locationAddresses: mybinder?.locationAddresses,
        });
      rows.forEach((row) => {
        if (row?.locationid && !row.covervalue) {
          for (const locid in action?.payload?.binderdetails?.locations) {
            if (locid == row?.locationid) {
              for (const key in action?.payload?.binderdetails?.locations[
                locid
              ]) {
                if (key == row?.id) {
                  row.covervalue =
                    action?.payload?.binderdetails?.locations[locid][key];
                }
              }
            }
          }
        }
      });

      mybinder.rows = [...rows];
    },
    gettingBinderDetailsFailed: (mybinder, action) => {
      mybinder.isLoading = true;
    },
    updateRows: (mybinder, action) => {
      mybinder.rows = action.payload.rows;
    },
    gettingBindersInitialized: (mybinder, action) => {
      mybinder.isLoading = true;
      mybinder.gettingMyBinders = true;
      mybinder.gettingMyBindersFailed = false;
      mybinder.gettingMyBindersSuccess = false;
    },

    gettingBindersFailed: (mybinder, action) => {
      mybinder.gettingMyBinders = false;
      mybinder.gettingMyBindersFailed = true;
      mybinder.gettingMyBindersSuccess = false;
    },

    gettingMyBindersSuccess: (mybinder, action) => {
      mybinder.gettingMyBinders = false;
      mybinder.gettingMyBindersFailed = false;
      mybinder.gettingMyBindersSuccess = true;

      //issue with binder being stored at the end incorrectly.
      const sortedBindersByDate = _.orderBy(
        action.payload.mybinders,
        ["effectivedate"],
        ["desc"]
      );
      mybinder.prospectorder = sortedBindersByDate;
      mybinder.order = convertArrayOfObjectsToId(sortedBindersByDate, "_id");
      mybinder.table = arrayToObjectForMyQuotes(sortedBindersByDate, "_id");
    },
    gettingClientDetailsInitialized: (mybinder, action) => {
      const prospectId = action.payload.prospectid;

      // Ensure the prospectId exists in the table
      if (!mybinder.table[prospectId]) {
        mybinder.table[prospectId] = {};
      }

      // Set the clientdetails property
      mybinder.table[prospectId].clientdetails =
        PossibleClientDetailsStatus.loading;
    },
    gettingClientDetailsSuccess: (mybinder, action) => {
      mybinder.currentClientDetails = action.payload.response.clientdetails;
      if (mybinder.table[action.payload.extras.prospectid]) {
        mybinder.table[action.payload.extras.prospectid].clientdetails =
          action.payload.response.clientdetails;
      } else {
        mybinder.table[action.payload.extras.prospectid] = {};
        mybinder.table[action.payload.extras.prospectid].clientdetails =
          action.payload.response.clientdetails;
      }
    },
    gettingClienteDetailsFailed: (mybinder, action) => {
      mybinder.table[action.payload.extras.prospectid].clientdetails =
        PossibleClientDetailsStatus.failed;
    },
    gettingSearchResultsSuccess: (mybinder, action) => {
      mybinder.searchedProspectIDs = action.payload.prospectIDs;
    },
    gettingBinderPociliesSuccess: (mybinder, action) => {
      mybinder.BinderPolicy = action.payload;
    },
    updateBinderCovers: (mybinder, action) => {
      mybinder.selectedBinderDetails.binderdetails.covers =
        action.payload.covers;
    },
    updateBrokerPolicyFailed: (mybinder, action) => {
      mybinder.updateError = action.payload;
    },

    binderLetterNull: (mybinder, action) => {
      mybinder.rows = [];
      mybinder.covers = null;
      mybinder.covertypes = null;
      mybinder.locationAddresses = {};
    },

    editBinderOrder: (mybinder, action) => {
      let key = action.payload.key;
      let tgt = mybinder.prospectorder.find(x => x._id == action.payload.policyid);
      if(tgt && key){
        tgt[key] = action.payload[key];
      }
    }

  },
});

export const {
  binderLetterNull,
  gettingBindersInitialized,
  gettingMyBindersSuccess,
  gettingBindersFailed,
  gettingClientDetailsInitialized,
  gettingClienteDetailsFailed,
  gettingClientDetailsSuccess,
  gettingSearchResultsSuccess,
  gettingBinderDetailsIsLoading,
  gettingBinderDetailsSuccess,
  gettingBinderDetailsFailed,
  gettingBinderPociliesSuccess,
  updateBinderCovers,
  updateRows,
  updateBrokerPolicyFailed,
  editBinderOrder
} = slice.actions;

export default slice.reducer;

// Action Creators

export const getBinderPolicies = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/policies/getbinderPolicies?id=" + data,
    method: "get",
    onStart: gettingBindersInitialized.type,
    onSuccess: gettingBinderPociliesSuccess.type,
    onError: gettingBindersFailed.type,
  });

export const getMyBinders = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/policies/get-my-binders",
    method: "post",
    data: data,
    onStart: gettingBindersInitialized.type,
    onSuccess: gettingMyBindersSuccess.type,
    onError: gettingBindersFailed.type,
  });
export const getBinderDetails = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/policies/get-binder-details",
    method: "post",
    data: data,
    onStart: gettingBindersInitialized.type,
    onSuccess: gettingBinderDetailsSuccess.type,
    onError: gettingBindersFailed.type,
  });

export const searchProspects = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/searchprospects?q=" + data,
    method: "get",
    onSuccess: gettingSearchResultsSuccess.type,
  });

export const getClientDetailsUsingProspectId = ({ prospectid }) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/propsectclientdetails",
    method: "post",
    data: { prospectid },
    onStart: gettingClientDetailsInitialized.type,
    onSuccess: gettingClientDetailsSuccess.type,
    onError: gettingClienteDetailsFailed.type,
    considerPayloads: true,
    onStartPayload: { prospectid },
    onSuccessPayload: { prospectid },
    onErrorPayload: { prospectid },
  });
export const updateBrokerCover = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/policies/updateBrokerPolicies",
    method: "post",
    data: data,
    onError: updateBrokerPolicyFailed.type,
  });

//Exeption
// export const updateBinderCovers = createAction(
//   updateBinderCovers.type,
//   function toggle(data) {
//     return {
//       payload: data,
//     };
//   }
// );
export const getGettingMyBinders = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => mybinder.gettingMyBinders
);

export const getGettingMyBindersSuccess = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => mybinder.gettingMyBindersSuccess
);

export const getGettingMyBindersFailed = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => mybinder.gettingMyBindersFailed
);

export const getArrayOfProspectsId = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => mybinder.order
);

export const getSearchedProspectsArray = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => mybinder.searchedProspectIDs
);

export const getFilteredProspectsIdArray =
  (broker, status, vertical, startdate, enddate, pids) => (state) => {
    var s = [];
    if (state.entities.mybinder.table) {
      for (const item of state.entities.mybinder.order) {
        let pros = state.entities.mybinder.table[item];
        if (pids && !pids.includes(pros.prospectid)) continue;
        if (startdate && pros.prospectlastupdated < startdate) continue;
        if (enddate && pros.prospectlastupdated > enddate) continue;
        if (broker != "" && pros.brokername != broker) continue;
        if (status != "" && pros.prospectstatus != status) continue;
        if (
          vertical != "" &&
          pros.vertical["en"] != vertical &&
          pros.vertical["fr"] != vertical
        )
          continue;
        s.push(item);
      }
    }
    return s;
  };

export const getBinders = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => mybinder
);

export const getCurrentClientDetails = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => mybinder.currentClientDetails
);

export const getBrokers = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => {
    var s = [];
    if (mybinder.order) {
      for (const item of mybinder.order) {
        let bname = mybinder.table[item].brokername;
        if (!s.includes(bname)) s.push(bname);
      }
    }
    return s;
  }
);

export const getStatus = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => {
    var s = [];
    if (mybinder.order) {
      for (const item of mybinder.order) {
        let sname = mybinder.table[item].prospectstatus;
        if (!s.includes(sname)) s.push(sname);
      }
    }
    return s;
  }
);

export const getAllPoliciesforCustomer =
  ({ prospectids }) =>
  (state) => {
    var pros_arr = [];
    if (prospectids && state.entities.mybinder && state.entities.mybinder.prospectorder)
    {
      prospectids.map(prospectid => {
        let binder = state.entities.mybinder.prospectorder.find(x => x.prospectid == prospectid);
        if(binder)
          pros_arr.push(binder) 
      } );
    }
    // console.log(state.entities.mybinder)
    for(var key in pros_arr){
      let status;
      const startDate = new Date(pros_arr[key]?.startdate);
      const expiryDate = new Date(pros_arr[key]?.expirydate);
      const currentDate = new Date();
      const isCancelled = pros_arr[key].isCancelled;
      if (isCancelled) {
        status = 'Cancelled';
      } else if (currentDate > expiryDate) {
        status = 'Expired';
      } else if (currentDate < startDate) {
        status = 'Pending';
      } else {
        status = 'In Force';
      }
      pros_arr[key] = {
        'Type': 'Policy',
        'Action' : {'type':'select', 'options':['View / Edit Application', 'Create Certificate',  'Create Binder Letter','View Policy', 'Add Additional Insureds / Loss Payees', 'View Transaction History', 'Add Policy Number']},
        'Status': status,
        'Last Updated': pros_arr[key].lastupdated,
        'Insurer': pros_arr[key]?.insurer,
        'Start Date' : pros_arr[key]?.startdate?.split("T")[0],
        'Expiry Date' : pros_arr[key]?.expirydate?.split("T")[0],
        'Id': pros_arr[key].bindernumber,
        'prospectid': pros_arr[key].prospectid,
        'productcode': pros_arr[key].productcode,
        //'Product': [pros_arr[key].vertical, pros_arr[key]?.prospectid],
        'binderid': pros_arr[key]._id,
      }
    }
    return pros_arr;
  };

export const getVertical = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => {
    var s = [];
    if (mybinder.order) {
      for (const item of mybinder.order) {
        let bname = mybinder.table[item].vertical;
        if (!s.includes(bname)) s.push(bname);
      }
    }
    return s;
  }
);

export const getRowDetailsFromProspectId =
  ({ prospectid }) =>
  (state) => {
    if (state.entities.mybinder && state.entities.mybinder.table)
      return state.entities.mybinder.table[prospectid];
    return {};
  };

export const getClientDetailStatus =
  ({ prospectid }) =>
  (state) =>
    state.entities.mybinder.table[prospectid]
      ? state.entities.mybinder.table[prospectid].clientdetails
      : {};

export const getSelectedBinderDetails = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => mybinder.selectedBinderDetails
);
export const getSelectedBinderDetailLocationAddress = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => mybinder.selectedBinderDetails?.binderdetails?.locationAddresses
);

export const getSelectedBinderPolicy = createSelector(
  (state) => state?.entities?.mybinder,
  (mybinder) => mybinder?.BinderPolicy?.BinderPolicy
);

export const getEncryCRSProspectIdFromMyBinders = () => (state) => {
  return state.entities.mybinder.selectedBinderDetails.binderdetails.crs;
};
export const getBinderViewRows = createSelector(
  (state) => state?.entities?.mybinder,
  (mybinder) => mybinder?.rows
);
export const getCovers = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => mybinder?.selectedBinderDetails?.binderdetails?.covers
);
export const getCoverTable = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => mybinder.covers
);
export const getCoverTypes = createSelector(
  (state) => state.entities.mybinder,
  (mybinder) => mybinder?.selectedBinderDetails?.binderdetails.covertypes
);
export const getBinderDetail = () =>
  createSelector(
    (state) => state.entities.mybinder,
    (mybinder) => mybinder?.selectedBinderDetails?.binderdetails
  );
export const getBrokerComment = createSelector(
  (state) => state?.entities?.mybinder,
  (mybinder) => mybinder?.BinderPolicy?.BinderPolicy?.brokercomment
);

export const getIsLoading = createSelector(
  (state) => state?.entities?.mybinder,
  (mybinder) => mybinder?.isLoading
);
